import { render, staticRenderFns } from "./CompanyUserSectors.vue?vue&type=template&id=f2afe9de&"
import script from "./CompanyUserSectors.vue?vue&type=script&lang=js&"
export * from "./CompanyUserSectors.vue?vue&type=script&lang=js&"
import style0 from "./CompanyUserSectors.vue?vue&type=style&index=0&id=f2afe9de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports